const submitFormOnChange = function() {
	document.querySelectorAll('.js-submit-form-on-change').forEach($trigger => {
		const $form =
			document.querySelector($trigger.dataset.submitFormRel) || $trigger.closest('form');
		$trigger.addEventListener('change', () => {
			$form.submit();
		});
	});
};

module.exports = submitFormOnChange;
